/**
 * Payouts API client. Read-only view of what the owner paid each office and the
 * staff under it, aggregated over a date range. Org-scoped like the rest of the
 * app — the caller supplies the org uuid from auth state.
 */
import api from './client';

const base = (orgUuid) => `/organisations/${orgUuid}/payouts`;

export const payoutsApi = {
    /**
     * Aggregated payouts for a date range (inclusive). Dates are 'YYYY-MM-DD'.
     *
     * @returns {
     *   from, to,
     *   totalUpfront, totalTrail, totalClawback, totalAdhoc, totalNet,
     *   offices: [{
     *     name, upfront, trail, clawback, adhoc, net,
     *     payees: [{ name, code, type, upfront, trail, adhoc, net }]
     *   }]
     * }
     */
    range(orgUuid, from, to) {
        return api
            .get(base(orgUuid), { params: { from, to } })
            .then((r) => r.data);
    },
};